export default {
    DIALOG_PADDING: 4,
    LANGUAGE_ITEM_HEIGHT: 32,
    LANGUAGE_ITEM_WIDTH: 104,
    LANGUAGE_ITEM_MARGIN: 4
};
